export const DELETE_TITLE = 'Confirmação de exclusão';
export const DELETE_MESSAGE = `
  Deseja realmente excluir esse funcionário?
  <br><br>
  <strong>
    Ao excluir o cadastro, os cálculos deste (a) funcionário (a) também serão excluídos do módulo folha.
  </strong>`;

export const DEFAULT_PAGINATION = {
  totalItems: 1,
  page: 1,
};

export const TABLE_HEADER_COLUMNS = [
  { name: 'Matrícula do eSocial', key: 'registration' },
  { name: 'Nome', key: 'name' },
  {
    name: 'Dados do contrato (Situação)', key: 'contract', sortable: false,
  },
  {
    name: 'Dados pessoais (Situação)', key: 'personal', sortable: false,
  },
  {
    name: '', key: 'actions', sortable: false,
  },
];

export const LINK_ESOCIAL_DEPLOYMENT_SCHEDULE = 'https://www.gov.br/esocial/pt-br/acesso-ao-sistema/cronograma-de-implantacao';
